// extracted by mini-css-extract-plugin
export default {"root":"RjQ762","line":"gwzcAr"};